module.exports = require("npm:baguettebox.js@1.10.0/dist/baguetteBox.min.js");